import service from '@/utils/server';

const modName='/log/logDetail/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'loginPageInfo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/int/logLoginDetail/api/index.js